import Vue from "vue";

export default {
  getClientSecret: async (amount) => {
      return Vue.axios
          .get(`Payment/payment-intent/${amount}`)
  },
  confirmEmail: (token, email) => {
    return Vue.axios
        .get(`Account/confirm-email?token=${token}&email=${email}`)
  },
  confirmPayment: (email) => {
    let token  = localStorage.getItem('token');
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow'
    };

    return fetch(`https://ontrac.azurewebsites.net/Account/confirm-payment/${email}`, requestOptions)
  }
}
